import { NormalizedCacheObject } from 'apollo-boost';

import { ImportWizardUploadMode } from '../typings/importWizard';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class ImportProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(apiManager: RestApiManager, client: DNAApolloClient<NormalizedCacheObject>) {
        super(client);
        this.apiManager = apiManager;
    }

    public uploadFile(login: string, file: File, importMode: ImportWizardUploadMode) {
        return this.apiManager.uploadImportFile(login, file, importMode);
    }

    public uploadImages() {
        return this.apiManager.uploadImportImages();
    }
}
